import React from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';

export default function Header({ roomCode, subtitle }) {
  const navigate = useNavigate();
  const isAdmin = api.isAdmin();
  const isDj    = api.isDj();

  const handleLogout = () => {
    api.clearSession();
    navigate('/login');
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-inner">
          <a className="header-logo" onClick={() => navigate('/')} style={{ cursor:'pointer' }}>
            <img src="/muzon/logo-small.png" alt="Muzon" className="header-logo-img" />
            <div>
              <span className="header-logo-text">Muzon</span>
              {subtitle && <span className="header-logo-sub">{subtitle}</span>}
            </div>
          </a>
          <div className="header-actions">
            {roomCode && <span className="header-room-code">{roomCode}</span>}
            {isAdmin && <span className="role-badge admin-badge">⚙ Администратор</span>}
            {isDj    && <span className="role-badge dj-badge">🎧 DJ</span>}
            {(isAdmin || isDj) && (
              <button className="btn btn-secondary btn-sm" onClick={handleLogout}>Выйти</button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
